<div class="container-fluid">
  <div *ngFor="let lRows of app.langData.pages[this.app.curPage].rows" class="row">
    <div class="col-lg-12 p-0">
      <div [ngClass]="{'container-fluid': lRows.fluid, 'container': !lRows.fluid}">
        <div class="row">
          <div *ngFor="let lData of lRows.cols" class="col-lg-{{lData.width}} p-0">
            <manager-pnl [aPanelData]="lData"></manager-pnl>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
